import React from 'react'
import { ForwardArrowLink } from 'src/component/forward-arrow-link/forward-arrow-link'

interface SeeAllProps extends Omit<React.ComponentProps<typeof ForwardArrowLink>, 'text' | 'link'> {
  seeAllLink: string
}

export const SeeAll = ({ seeAllLink, ...props }: SeeAllProps): React.ReactElement => {
  return <ForwardArrowLink {...props} text="See All" link={seeAllLink} />
}
